import client from './client';

export interface CardData {
  dailyTotalPower: string;
  weeklyTotalPower: string;
  monthlyTotalPower: string;
  yearlyTotalPower: string;
  lifetimeTotalPower: string;
  plantsCount: number;
  activePlantsCount: number;
  invertersCount: number;
  activeInvertersCount: number;
  alarmTotalCount: number;
  alarmWarningCount: number;
  alarmMinorCount: number;
  alarmMajorCount: number;
  taskTotalCount: number;
  taskTodoCount: number;
  taskInProgressCount: number;
  taskDoneCount: number;
  taskCanceledCount: number;
  sensorsCount: number;
  activeSensorsCount: number;
  topPlantsToday: Array<{
    rank: number;
    powerPlantUuidId: string;
    powerPlantName: string;
    investorName: string;
    powerTotal: string;
  }>;
}

export interface PowerData {
  date_hour?: number;
  date_name: string;
  power_total: number;
  date_year?: number;
  date_month?: number;
  date_day?: number;
}

export interface PowerChartData {
  hourly?: PowerData[];
  daily: PowerData[];
  monthly: PowerData[];
  yearly: PowerData[];
}

export async function fetchCardData(tagIds: number[] = [], plantUuidId?: string | null): Promise<CardData> {
  const params: Record<string, string> = {};
  if (tagIds.length > 0) params.tag_ids = tagIds.join(',');
  if (plantUuidId) params.plant_uuid_id = plantUuidId;
  const res = await client.get<CardData>('/dashboard/cards', {
    params: Object.keys(params).length > 0 ? params : undefined,
  });
  return res.data;
}

export async function fetchPowerChart(tagIds: number[] = [], plantUuidId?: string | null): Promise<PowerChartData> {
  const params: Record<string, string> = {};
  if (tagIds.length > 0) params.tag_ids = tagIds.join(',');
  if (plantUuidId) params.plant_uuid_id = plantUuidId;
  const res = await client.get<PowerChartData>('/dashboard/power-chart', {
    params: Object.keys(params).length > 0 ? params : undefined,
  });
  return res.data;
}

export async function fetchDrillChart(
  year: number,
  month: number | null,
  day: number | null = null,
  tagIds: number[] = [],
  plantUuidId?: string | null,
): Promise<PowerData[]> {
  const params: Record<string, string> = { year: String(year) };
  if (month !== null) params.month = String(month);
  if (day !== null) params.day = String(day);
  if (tagIds.length > 0) params.tag_ids = tagIds.join(',');
  if (plantUuidId) params.plant_uuid_id = plantUuidId;
  const res = await client.get<{ data: PowerData[] }>('/dashboard/power-chart/drill', { params });
  return res.data.data;
}
